export enum ValidationType {
  Invalid = 'invalid',
  DataType = 'data_type',
  Required = 'required',
  MustBeTrue = 'must_be_true',
  Min = 'min',
  Max = 'max',
  AllowedValues = 'allowed_values',
  Regex = 'regex',
  NotAllowedValues = 'not_allowed_values',
  // Add more as needed
}

export enum DataType {
  String = 'string',
  Integer = 'integer',
  Boolean = 'boolean',
  Date = 'date',
}
